import {Component, Input} from "@angular/core";
import {SessionEvents} from "../../orchestration/session-events";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";

@Component({
    host: {
        "class": "logo"
    },
    selector: "woa-logo",
    templateUrl: "./logo.component.html",
})
export class LogoComponent {
    @Input() type: "vertical" | "horizontal";

    constructor(public orderingContextModel: OrderingContextModel) {
    }

    SessionEvents = SessionEvents;

    showHorizontalLogo(): boolean {
        return this.type === "horizontal" || !this.orderingContextModel.verticalLogoImage;
    }

    showVerticalLogo(): boolean {
        return this.type === "vertical" && !!this.orderingContextModel.verticalLogoImage;
    }

    px(size: number) {
        return size === undefined ? undefined : size + "px";
    }
}



// WEBPACK FOOTER //
// ./src/app/ui-elements/logo/logo.component.ts